import { Chip } from "@mui/material";
import { useLocation } from "react-router";
import { matchRouteContext } from "../../lib/argus/route-registry";

/**
 * Small chip that shows the user's current route context inside the Argus
 * sidebar header. Renders "General context" on unmatched routes so users
 * always know whether Argus will prepend a specific resource reference.
 */
export const ArgusContextPill = () => {
  const location = useLocation();
  const context = matchRouteContext(location.pathname);
  if (!context) return null;
  return (
    <Chip
      size="small"
      label={context.label}
      variant="outlined"
      sx={{ fontSize: "11px", height: "20px" }}
    />
  );
};
